import { useState, useMemo } from "react";

const useSort = (items) => {
  const [sortConfig, setsortConfig] = useState(null);

  const sortedItems = useMemo(() => {
    let sortableItems = items.length !== 0 ? [...items] : [];
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.ref] < b[sortConfig.ref]) {
          return sortConfig.sortType === "ascending" ? -1 : 1;
        }
        if (a[sortConfig.ref] > b[sortConfig.ref]) {
          return sortConfig.sortType === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableItems;
  }, [items, sortConfig]);

  const requestSort = (ref) => {
    if (ref === null) {
      setsortConfig(null);
      return;
    }
    let sortType = "ascending";
    if (sortConfig && sortConfig.ref === ref && sortConfig.sortType === "ascending") {
      sortType = "descending";
    }
    setsortConfig({ ref, sortType });
  };

  return { items: sortedItems, sortConfig, requestSort };
};

export default useSort;
